import { t } from 'i18next'
import { toast } from 'react-toastify'

import { ToastMessageType } from './const'
import { Toast } from './Toast'
import { APIErrorResponse } from '@/Data/types'

export const showToast = (
  variant: ToastMessageType,
  headline: string,
  text?: string,
) => {
  toast(<Toast variant={variant} headline={headline} text={text} />)
}

export const errorToast = (error: Error) => {
  const { headline, text } = errorMessageFormatter(error)
  showToast(ToastMessageType.ERROR, headline, text)
}

const errorMessageFormatter = (error: APIErrorResponse) => {
  const defaultText = t('errors.unknownError.headline')
  const headline = error?.message || defaultText
  const text = error?.details?.validation_errors?.[0]?.message || ''

  return { headline, text }
}
